module.exports = __webpack_public_path__ + "img/grp check.c53e0128.png";